module.exports = __webpack_public_path__ + "static/media/question-small.b98f4176.svg";